import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosSharedReembolsoDialogoComponent {
  anticipo = undefined
  onClose

  cerrar (opcion) {
    this.onClose({$event: {detail: opcion}})
  }

}

module.component('viaticosSharedReembolsoDialogo', {
  controller: ViaticosSharedReembolsoDialogoComponent,
  template,
  bindings: {
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/shared/reembolso/dialogo/component.js